module.exports = __webpack_public_path__ + "img/page2-two.b281a416.png";